import React from 'react';
import { motion } from 'framer-motion';
import { Building2, Globe2, Shield, Award } from 'lucide-react';
export function AboutUs() {
  return <section id="about" className="py-24 bg-white" data-id="element-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-21">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-22">
          {/* Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-23">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-24">
              About Us
            </h2>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed" data-id="element-25">
              Kale Cooperative Minerals SPRL is a certified mining and mineral
              trading company based in the République Démocratique du Congo
              (RDC), operating worldwide. We specialize in supplying
              high-quality, ethically sourced minerals to international markets.
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed" data-id="element-26">
              Our expertise lies primarily in Gold, along with Diamonds and
              other valuable Gemstones. As a legally registered and certified
              company, we are committed to maintaining the highest standards of
              quality, professionalism, and ethical sourcing practices.
            </p>

            <div className="grid grid-cols-2 gap-6" data-id="element-27">
              <div className="flex items-start space-x-3" data-id="element-28">
                <div className="bg-drc-blue/10 p-3 rounded-lg text-drc-blue" data-id="element-29">
                  <Building2 size={24} data-id="element-30" />
                </div>
                <div data-id="element-31">
                  <h3 className="font-semibold text-gray-900 mb-1" data-id="element-32">
                    RDC Based
                  </h3>
                  <p className="text-sm text-gray-600" data-id="element-33">
                    Operating from Goma, Nord-Kivu
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-3" data-id="element-34">
                <div className="bg-drc-blue/10 p-3 rounded-lg text-drc-blue" data-id="element-35">
                  <Globe2 size={24} data-id="element-36" />
                </div>
                <div data-id="element-37">
                  <h3 className="font-semibold text-gray-900 mb-1" data-id="element-38">
                    Global Reach
                  </h3>
                  <p className="text-sm text-gray-600" data-id="element-39">
                    Serving international markets
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-3" data-id="element-40">
                <div className="bg-drc-blue/10 p-3 rounded-lg text-drc-blue" data-id="element-41">
                  <Shield size={24} data-id="element-42" />
                </div>
                <div data-id="element-43">
                  <h3 className="font-semibold text-gray-900 mb-1" data-id="element-44">
                    Ethical Sourcing
                  </h3>
                  <p className="text-sm text-gray-600" data-id="element-45">
                    Conflict-free guarantee
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-3" data-id="element-46">
                <div className="bg-drc-blue/10 p-3 rounded-lg text-drc-blue" data-id="element-47">
                  <Award size={24} data-id="element-48" />
                </div>
                <div data-id="element-49">
                  <h3 className="font-semibold text-gray-900 mb-1" data-id="element-50">
                    Best Quality
                  </h3>
                  <p className="text-sm text-gray-600" data-id="element-51">Premium minerals only</p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative" data-id="element-52">
            <div className="relative h-[500px] rounded-2xl overflow-hidden shadow-2xl" data-id="element-53">
              <img src="https://cdn.magicpatterns.com/uploads/d3XDSHtuc9vayzSX7JJKWc/cheapest-gold-in-africa.jpg" alt="Premium Gold Bars from RDC" className="w-full h-full object-cover" data-id="element-54" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" data-id="element-55" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}